import gql from 'graphql-tag';

const getCcxDetails = /* GraphQL */ gql`
  query GetCcxDetails(
    $channel: String!
    $directReports: [String!]
    $isTM: Boolean!
    $segment: String!
    $skill: String!
    $marketplace: String
    $syncMetrics: Boolean
    $timeOption: TimeOption!
    $timestamp: String!
    $userID: String!
    $vertical: String!
  ) {
    getCCXDetails(
      channel: $channel
      directReports: $directReports
      isTM: $isTM
      segment: $segment
      skill: $skill
      marketplace: $marketplace
      syncMetrics: $syncMetrics
      timeOption: $timeOption
      timestamp: $timestamp
      userID: $userID
      vertical: $vertical
    ) {
      details {
        ccxCourtesy
        ccxEfficiency
        ccxEmpathy
        ccxHelpfulness
        ccxKnowledgeable
        ccxOverall
        ccxUnderstand
        channelCode
        communicationDate
        contactID
        encryptedRapRepeatContactId
        issueCode
        marketplaceName
        rapRepeatContactId
        responseDate
        userID
        workCategory
        contactStatus
      }
      lastAuditDate
    }
  }
`;

const getCCXForContact = /* GraphQL */ gql`
  query GetCCXForContact(
    $userID: String!
    $startDate: String!
    $endDate: String!
    $contactID: String!
  ) {
    getCCXForContact(
      userID: $userID
      startDate: $startDate
      endDate: $endDate
      contactID: $contactID
    ) {
      details {
        ccxCourtesy
        ccxEfficiency
        ccxEmpathy
        ccxHelpfulness
        ccxKnowledgeable
        ccxOverall
        ccxUnderstand
        channelCode
        communicationDate
        contactID
        encryptedRapRepeatContactId
        issueCode
        marketplaceName
        rapRepeatContactId
        responseDate
        userID
        workCategory
      }
      lastAuditDate
    }
  }
`;

const getContactStatusList = /* GraphQL */ gql`
  query GetContactStatusList(
    $users: [String!]!
    $startWeek: String!
    $endWeek: String!
  ) {
    getContactStatusList(
      users: $users
      startWeek: $startWeek
      endWeek: $endWeek
    ) {
      contactStatuses {
        commId
        contactStatus
        formReviews {
          formID
          version
          formAnswer {
            questionID
            questionText {
              defaultMessage
              translationID
            }
            selectedOption {
              defaultMessage
              translationID
            }
            answerText
            value
          }
        }
      }
    }
  }
`;

export { getCcxDetails, getCCXForContact, getContactStatusList };
